/**
 * Ryan O'Dowd
 * 2025-05-30
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    cardName: {
      fontSize: globalScale * 18,
      color: globals.appName === 'wrinkly' ? colors.white : colors.primary, // @TODO: don't like business logic ternaries
      marginBottom: globalScale * 4,
      fontFamily: fonts.secondaryBold,
    },
    textWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginTop: 8,
    },
    lineItemIcon: {
      marginTop: 6,
      marginRight: 4,
      fontSize: 6,
      color: globals.appName === 'wrinkly' ? colors.white : isDarkMode ? colors.white : colors.black,
    },
    cardBodyLine: {
      flex: 1,
      fontSize: globalScale * 16,
      color: globals.appName === 'wrinkly' ? colors.white : isDarkMode ? colors.white : colors.black,
    },
    swipeoutButtonView: {
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minWidth: 64,
      padding: 4,
      margin: 8,
    },
    timestampText: {
      width: '100%',
      marginLeft: 8,
      marginRight: 8,
      color: colors.white,
      textAlign: 'center',
    },
  };
};

export default getStyles;
